import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { ClientSummary, Client } from '../../types';
import { clientService } from '../../services/clientService';

interface ClientsState {
  list: ClientSummary[];
  selected: Client | null;
  loading: boolean;
  error: string | null;
}

const initialState: ClientsState = {
  list: [],
  selected: null,
  loading: false,
  error: null,
};

export const fetchClients = createAsyncThunk('clients/fetchAll', () => clientService.getAll());
export const fetchClientById = createAsyncThunk('clients/fetchById', (id: number) => clientService.getById(id));
export const createClient = createAsyncThunk('clients/create', (data: Partial<Client>) => clientService.create(data));
export const updateClient = createAsyncThunk('clients/update', ({ id, data }: { id: number; data: Partial<Client> }) =>
  clientService.update(id, data)
);
export const deleteClient = createAsyncThunk('clients/delete', async (id: number) => {
  await clientService.delete(id);
  return id;
});

const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    clearSelected: (state) => { state.selected = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClients.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchClients.fulfilled, (state, action: PayloadAction<ClientSummary[]>) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchClients.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? 'Erreur de chargement';
      })
      .addCase(fetchClientById.fulfilled, (state, action: PayloadAction<Client>) => {
        state.selected = action.payload;
      })
      .addCase(createClient.fulfilled, (state) => { state.loading = false; })
      .addCase(updateClient.fulfilled, (state, action: PayloadAction<Client>) => {
        state.selected = action.payload;
      })
      .addCase(deleteClient.fulfilled, (state, action: PayloadAction<number>) => {
        state.list = state.list.filter((c) => c.id !== action.payload);
      });
  },
});

export const { clearSelected } = clientsSlice.actions;
export default clientsSlice.reducer;
